<template>
	<v-app>
		<sheader></sheader>
		<v-main>
			<v-container class="pm-frame pa-0 mb-5">
				<v-row>
					<v-col md="3" class="py-0" v-if="!isMobile">
						<smenubar></smenubar>
					</v-col>
					<v-col :md="(isMobile) ? 12 : 9" class="py-5 my-3">
						<router-view></router-view>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<sfooter></sfooter>
	</v-app>
</template>

<script>
import { mapActions } from 'vuex'
import sheader from '@/components/layout/store/seller/Header';
import sfooter from '@/components/layout/store/seller/Footer';
import smenubar from '@/components/layout/store/seller/Sidebar';

export default {
	components: {
		sheader, smenubar, sfooter
	},
	
	data() {
		return {
			isMobile: false,
		}
	},

	computed: {
		windowWidth() {
      return this.getWindowWidth()
		}
	},

	methods: {
		...mapActions('storeSeller', ['getStoreDetail']),
		getWindowWidth() {
      let screen = document.documentElement.clientWidth
      if (screen <= 600) this.isMobile = true
      else this.isMobile = false
		},
	},

	created() {
		this.getStoreDetail()
    this.getWindowWidth()
    window.addEventListener('resize', this.getWindowWidth)
  },
  destroyed() {
    window.addEventListener('resize', this.getWindowWidth)
  },

}
</script>